export default "__VITE_ASSET__DkBk8Saa__"